import { Card, Col, Row } from "antd";
import { useState } from 'react'
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { CalendarOutlined, InfoCircleOutlined, NotificationOutlined, StarFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './ContentsSummary.css'
import '../../../../styles/Summaries.css';
import { Column, DualAxes } from "@ant-design/charts";
import MathUtils from "../../../../common/utils/MathUtils";
import { SpinLZ } from "../../../components/design/Spinner/SpinLZ";
import PDFGenerator from "../../../components/model/pdf/GeneratePDF";
import { SCHEDULEDJOB } from "../../../../common/constants/services";
import { Synchronized } from "../../../components/design/Synchronized/Synchronized";
import Tooltip from "antd/es/tooltip";
import { BlockContentKpis } from "../blocks/BlockContentKpis";
import { BlockContentGlobal } from "../blocks/BlockContentGlobal";
import { PageTitle } from "../../common/PageTitle";

export const ContentsSummary = () => {

    const { projectGroup } = useAuth();

    const { t } = useTranslation();
    
    const [kpis, setKpis] = useState<any>(null);
    const [content, setContent] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);

    useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + projectGroup.group + '/summary/contents', {}, [],
        (data: any) => {
            setKpis(data.postKPIs);
            setContent(data);
            setIsLoading(false);
        });        

    return (
        <div>
            <Card className='main-card-content' id='element-to-capture'>

                <Synchronized service={[SCHEDULEDJOB.GBP_POSTS]}/>	
                
                <PageTitle
                    title={t('reviews.page.global.title') as string}
                    pageInfo='Visualiza las publicaciones que estás haciendo en Google Business Profile y los datos de rendimiento de las mismas. Ofrecemos en esta pantalla también una visión global en el caso que publiques el mismo contenido en múltiples establecimientos.'
                />

                {isLoading ? <SpinLZ/> : <div className="card-container" style={{ marginTop: 14, padding: '6px 0 0' }}>

                    {kpis && <BlockContentKpis kpis={kpis}/>}
                    {content && <BlockContentGlobal data={content}/>}
                    
                </div>
                }
            </Card>
        </div>
    )
}